import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUserWithRedirect, logout } from 'auth/authUtils';
import { authenticatingUser } from 'redux/actions/auth';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { MenuItem, Button, IconButton, makeStyles } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles({
    appBar: {
        alignItems: 'center',
        backgroundImage: 'linear-gradient(45deg,var(--colorsViolet,#3a397b),var(--colorsCuriousBlue,#3190d9))',
        color: '#fff',
        zIndex: '1000',
    },
    toolbar: {
        maxWidth: '84em',
        width: '100%',
        padding: 0,
    },
    title: {
        paddingLeft: '10px',
        flexGrow: 1,
        '&:hover': {
            cursor: 'pointer',
        },
    },
});

const Header = (props) => {
    const { openMenu } = props;
    const auth = useSelector((state) => state.user);
    const userAuthenticating = useSelector((state) => state.user.authenticatingUser);
    const [showMobileView, setShowMobileView] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();

    const login = () => {
        dispatch(authenticatingUser());
        loginUserWithRedirect();
    };

    useEffect(() => {
        function handleResize(e) {
            setShowMobileView(e.matches);
        }

        window.innerWidth <= 755 && setShowMobileView(true);

        window.matchMedia('(max-width: 755px)').addListener((e) => handleResize(e));
    }, []);

    return (
        <>
            <AppBar position='static' className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <Typography variant='h6' color='inherit' className={classes.title} onClick={() => history.push('/')}>
                        QDash
                    </Typography>
                    {showMobileView ? (
                        <IconButton onClick={openMenu} edge='start' color='inherit' aria-label='menu'>
                            <MenuIcon />
                        </IconButton>
                    ) : (
                        <>
                            <MenuItem onClick={() => history.push('/')}>
                                <Typography component='div' color='inherit'>
                                    Home
                                </Typography>
                            </MenuItem>
                            {auth.authenticated && (
                                <>
                                    <MenuItem onClick={() => history.push('/mydashboards')}>
                                        <Typography component='div' color='inherit'>
                                            My Dashboards
                                        </Typography>
                                    </MenuItem>
                                    <MenuItem onClick={() => history.push('/search')}>
                                        <Typography component='div' color='inherit'>
                                            Search Dashboards
                                        </Typography>
                                    </MenuItem>
                                </>
                            )}
                            {auth.admin && (
                                <MenuItem onClick={() => history.push('/managerportal')}>
                                    <Typography component='div' color='inherit'>
                                        Manager Portal
                                    </Typography>
                                </MenuItem>
                            )}
                            <MenuItem>
                                {userAuthenticating && <div>Logging in...</div>}
                                {!userAuthenticating && auth.authenticated && (
                                    <Button variant='contained' onClick={logout}>
                                        Log Out
                                    </Button>
                                )}
                                {!userAuthenticating && !auth.authenticated && (
                                    <Button variant='contained' onClick={login}>
                                        Log In
                                    </Button>
                                )}
                            </MenuItem>
                        </>
                    )}
                </Toolbar>
            </AppBar>
        </>
    );
};

export default Header;
